import React, { useState } from 'react'
import * as R from 'ramda'
import { notificationEventStatus } from 'app/main/notification/useNotificationEventStatus'
import {
  Icon,
  Typography,
  MenuItem,
  Button,
  Menu,
  useMediaQuery,
} from '@material-ui/core'
import { FormattedMessage, useIntl } from 'react-intl'
import CancelEventNotification from 'app/main/messages/notificationTimeline/CancelEventNotification'
import {
  useTooltipTitle,
  TooltipStatus,
} from 'app/main/messages/notificationTimeline/status/TooltipStatus'
import {
  isUnsent,
  isCanceled,
  isEnded,
} from 'app/main/messages/notificationTimeline/unsendNotification/unsendNotificationLogic'
import AccessControl from 'app/auth/AccessControl'
import { AccessType } from 'app/auth/accessControlService'
import { useTheme } from '@material-ui/styles'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/styles'
import Assets from 'app/configs/assetConfigs'
import { useSelector } from 'react-redux'

const useStyles = makeStyles((theme) => ({
  textSize14: {
    fontSize: '14px !important',
  },
  dangerColor: {
    color: '#f74872',
  },
}))

const EventNotificationActions = ({
  handleDownloadEventSummary,
  handleEditMenu,
  selectedMenu,
  handleClickSelectMenu,
  onCloseSelectMenu,
  notification,
}) => {
  const classes = useStyles()
  const { formatMessage } = useIntl()
  const [isOpenCancelEventDialog, setIsOpenCancelEventDialog] = useState(false)
  const theme = useTheme()
  const isDownXs = useMediaQuery(theme.breakpoints.down('xs'))
  const { id } = useSelector(({ auth }) => auth.user.data)
  const isEndedValue = isEnded(notification)

  const isShowDownloadEvent = R.includes(R.prop('eventStatus')(notification), [
    notificationEventStatus.upcoming.status,
    notificationEventStatus.happening.status,
  ])

  const handleOpenCancelEventDialog = () => {
    setIsOpenCancelEventDialog(true)
    onCloseSelectMenu()
  }
  const handleCloseCancelEventDialog = () => {
    setIsOpenCancelEventDialog(false)
  }

  const createTooltipTitle = useTooltipTitle()

  if (R.anyPass([isUnsent, isCanceled])(notification)) {
    const performDate = R.prop('unsentDate', notification)
    const person = R.prop('unsentBy', notification)
    const titleObj = createTooltipTitle(person, performDate)
    const isCanceledValue = isCanceled(notification)

    const title = formatMessage(
      {
        id: isCanceledValue
          ? 'notificationTimeline.card.cancelBy.title'
          : 'notificationTimeline.card.deleteBy.title',
      },
      titleObj,
    )

    const status = (
      <FormattedMessage
        id={
          isCanceledValue
            ? 'notificationTimeline.card.status.canceled'
            : 'notificationTimeline.card.status.deleted'
        }
      />
    )

    return (
      <TooltipStatus
        title={isCanceledValue ? status : title}
        status={status}
        className={clsx(isDownXs ? '' : 'p-8')}
      />
    )
  }

  return (
    <AccessControl accesses={[AccessType.ADMINISTRATION]}>
      {(isGranted) =>
        R.or(isGranted, R.equals(R.prop('posterId', notification), id)) && (
          <>
            {!isEndedValue ? (
              <>
                <Button
                  className={clsx('min-w-4', isDownXs ? 'p-0 m-0' : '')}
                  aria-controls="simple-menu"
                  aria-haspopup="true"
                  onClick={handleClickSelectMenu}
                >
                  <Icon>more_vert</Icon>
                </Button>
                <Menu
                  id="simple-menu"
                  className="mt-36"
                  anchorEl={selectedMenu}
                  keepMounted
                  open={Boolean(selectedMenu)}
                  onClose={onCloseSelectMenu}
                >
                  {isShowDownloadEvent && (
                    <MenuItem
                      className="min-h-12"
                      onClick={() => handleDownloadEventSummary('pdf')}
                    >
                      <img
                        src={Assets.event.eventIcPdf}
                        className="ltr:mr-4 rtl:ml-4"
                        alt="event location icon"
                      />
                      <Typography
                        variant="caption"
                        className={classes.textSize14}
                      >
                        <FormattedMessage id="notificationTimeline.card.event.downloadEventSummaryPdf" />
                      </Typography>
                    </MenuItem>
                  )}
                  {isShowDownloadEvent && (
                    <MenuItem
                      className="min-h-12"
                      onClick={() => handleDownloadEventSummary('csv')}
                    >
                      <img
                        src={Assets.event.eventIcCsv}
                        className="ltr:mr-4 rtl:ml-4"
                        alt="event location icon"
                      />
                      <Typography
                        variant="caption"
                        className={classes.textSize14}
                      >
                        <FormattedMessage id="notificationTimeline.card.event.downloadEventSummaryCsv" />
                      </Typography>
                    </MenuItem>
                  )}
                  <MenuItem className="min-h-12" onClick={handleEditMenu}>
                    <img
                      src={Assets.event.eventIcEdit}
                      className="ltr:mr-4 rtl:ml-4"
                      alt="event location icon"
                    />
                    <Typography
                      variant="caption"
                      className={classes.textSize14}
                    >
                      <FormattedMessage id="edit.label" />
                    </Typography>
                  </MenuItem>
                  <MenuItem
                    className="min-h-12"
                    onClick={handleOpenCancelEventDialog}
                  >
                    <img
                      src={Assets.event.eventIcDelete}
                      className="ltr:mr-4 rtl:ml-4"
                      alt="event location icon"
                    />
                    <Typography
                      variant="caption"
                      className={clsx(classes.textSize14, classes.dangerColor)}
                    >
                      <FormattedMessage id="notificationTimeline.card.event.cancel" />
                    </Typography>
                  </MenuItem>
                </Menu>
                {isOpenCancelEventDialog && (
                  <CancelEventNotification
                    notificationId={R.prop('id', notification)}
                    onClose={handleCloseCancelEventDialog}
                  />
                )}
              </>
            ) : null}
          </>
        )
      }
    </AccessControl>
  )
}

export default React.memo(EventNotificationActions)
